import script from "./ArchiveMainAutoMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchiveMainAutoMessage.vue?vue&type=script&setup=true&lang=js"

import "./ArchiveMainAutoMessage.vue?vue&type=style&index=0&id=e435bbba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e435bbba"]])

export default __exports__